import { useNavigate } from 'react-router-dom'
import { Home, Layers, MessageCircle } from 'lucide-react'
import { haptics } from '../../lib/haptics'

export type Tab = 'home' | 'models' | 'chat'

interface Props {
  activeTab: Tab
}

const tabs: Array<{ id: Tab; label: string; icon: typeof Home; path: string }> = [
  { id: 'home',   label: 'Home',   icon: Home,          path: '/' },
  { id: 'models', label: 'Models', icon: Layers,        path: '/models' },
  { id: 'chat',   label: 'Chat',   icon: MessageCircle, path: '/chat' },
]

export default function TabBar({ activeTab }: Props) {
  const navigate = useNavigate()

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 flex items-stretch"
      style={{
        backgroundColor: 'var(--tab-bar-bg)',
        height: 'calc(var(--tab-bar-height) + var(--safe-bottom))',
        paddingBottom: 'var(--safe-bottom)',
      }}
    >
      {tabs.map(({ id, label, icon: Icon, path }) => {
        const isActive = id === activeTab
        return (
          <button
            key={id}
            onClick={() => {
              haptics.impact('light')
              navigate(path)
            }}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 transition-opacity active:opacity-70"
          >
            <Icon
              size={22}
              strokeWidth={isActive ? 2.2 : 1.5}
              style={{
                color: isActive
                  ? 'var(--tg-theme-button-color)'
                  : 'var(--tg-theme-hint-color)',
              }}
            />
            <span
              className="text-[10px] font-medium"
              style={{
                color: isActive
                  ? 'var(--tg-theme-button-color)'
                  : 'var(--tg-theme-hint-color)',
              }}
            >
              {label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
